import {LocationDropdown} from "@/services/location.service";
import InputDropdown from "@/components/input-dropdown/InputDropdown";
import InputDatePicker from "@/components/input-date-picker/InputDatePicker";
import moment from "moment";
import router from "@/router";
import {GroupDropdown, SpotDropdown} from "@/services/group.service";
import InputDropdownMenu from "@/components/input-dropdown-menu/InputDropdownMenu";
import InputDropdownCheckbox from "@/components/input-dropdown-checkbox/InputDropdownCheckbox";
import InputDropdownSearch from "@/components/input-dropdown-search/InputDropdownSearch";
import {BookingDropdown, BookingOptionDropDown, BookingService} from "@/services/booking.service";
import Card from '../../components/card/Card'
import {CookieService} from "@/services/cookie.service";

export default {
    name: 'VisitsOptionsContainer',
    components: {
        InputDropdown,
        InputDropdownMenu,
        InputDropdownCheckbox,
        InputDropdownSearch,
        InputDatePicker,
        Card
    },

    props: {
        arrivalDate: Date,
        entityModeVisits: Boolean,
        isBookingAgent: Boolean,
        locations: Array,
        location: Object,
        bookingOption: Object,
        timeSlots: Array,
        activeTimeSlots: Array,
        entities: Array,
        preferences: Object,
        bookingOptions: [],
    },

    data() {
        return {
            bookingsDropDown: [],
            groupsDropDown: [],
            filteredEntities: [],
            spotsDropDown: [],
            showExportCard: false,
            entityMode: true,
        }
    },

    async mounted() {
        // set entityMode from parent and sets cookies if they are given from parent component
        this.entityMode = this.entityModeVisits;
        if (this.preferences) {
            if (this.preferences.groups) {
                this.groupsDropDown = this.preferences.groups
                this.updateGroups()
            }
        }
    },

    computed: {
        // fill location dropdown
        locationDropDown() {
            return this.locations.map(o => new LocationDropdown(o))
        },

        // track the status of the group dropdown
        groupsDropDownValue() {
            let values = this.getDropdownValues(this.groupsDropDown)
            return values.join(', ')
        },

        // track the status of the spots dropdown
        spotsDropDownValue() {
            let values = this.getDropdownValues(this.spotsDropDown)
            return values.join(', ')
        },

        optionsDropDown() {
            return this.bookingOptions?.map(o => new BookingOptionDropDown(o.id,o.name))
        }
    },

    watch: {
        // repopulate groups when location changes (triggered by parent component)
        location: {
            immediate: true,
            handler: function(){
                this.populateDropdownGroups()
                this.getSearchableBookings(this.location)
            }
        }
    },

    methods: {
        // populate the groups dropdown with groups in selected location, reset filteredEntities and trigger update
        populateDropdownGroups () {
            this.groupsDropDown = this.location.groups.map(o => new GroupDropdown(o))
            this.filteredEntities = this.entities
            this.$emit("filteredEntitiesUpdate", this.filteredEntities)
        },

        // trigger arrivalDate update in parent
        arrivalDateUpdate: async function(date){
            this.$emit("updateArrivalDate", date)
        },

        // trigger location update in parent
        updateLocation: async function(id) {
            this.$emit("locationUpdate", id)
        },

        updateBookingOption: async function(id){
            this.$emit("bookingOptionUpdate", id)
        },

        /**
         * Function that gets all the searchable bookings
         * @param location the location of the bookings
         * @return {Promise<void>}
         */
        getSearchableBookings: async function(location){
            let startDateString = moment().subtract(1, 'months').toDate().toISOString() // you can search for half a year back
            let endDateString =  moment().add(1, 'weeks').toDate().toISOString() // and half a year in the future

            await BookingService.getBookingsByLocation(location, startDateString, endDateString,false)// get all the bookings
                .then((bookings) => {
                    let dropdownBookings = []
                    for (let i = 0; i < bookings.length; i++) {
                        let b = bookings[i]
                        if (b.options !== undefined) {
                            if ( b.options.length !== 0 ) {
                                dropdownBookings.push(new BookingDropdown(b.id, b.licensePlate, b.customer.name, b.options, b.entity.startDate, b.vehicleArrivalDate, b.vehicleDepartureDate)) // fill the search bar
                            }
                        }
                    }
                    dropdownBookings.sort((a,b) => moment(b.startdate).toDate() - moment(a.startDate).toDate())
                    this.bookingsDropDown = dropdownBookings
                }).catch ((error) => {
                    console.warn("No bookings")
                })

        },

        /**
         * Triggered when groups are filtered in the groupsDropDown, filters out the entities and spots of the selected groups
         * and sends those updates to the parent component (also stores them in cookie)
         */
        updateGroups() {
            let values = this.getDropdownValues(this.groupsDropDown) // get selected groups
            let groups = _.uniq(this.location.groups.filter(g => values.includes(g.name))) // get the group options
            let entities = groups.map(g => g.entities) // filter entities
            entities = entities.flat() // combine entities
            this.filteredEntities = this.entities.filter(e => entities.map(ent => ent.id).includes(e.id)) // filter entities

            this.$emit("filteredEntitiesUpdate", this.filteredEntities)
            this.$emit("spotsChanged", this.filteredSpots)
            this.storePreferences()
        },

        // returns the values in passed dropdown
        getDropdownValues(dropdownItems) {
            const values = []
            for (const dropdownItem of dropdownItems) {
                if (dropdownItem.checked) {
                    values.push(dropdownItem.value)
                }
            }
            return values
        },

        // closes export card
        closeExportCard() {
            this.showExportCard = false
        },

        search (selectedID) {
            router.push(`/booking/${selectedID}`)
        },

        /**
         * Function that stores the filters in a cookie
         */
        storePreferences() {
            let preference = {
                "location": this.location.id,
                "groups": this.groupsDropDown ? this.groupsDropDown : [],
            }
            CookieService.storeCookie("preference", preference, 365)
        }
    }
}
